import React, { Component } from "react";
import lockr from 'lockr';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from "./styles/styled-components";
import { theme } from "./styles/theme-playsports";

import CookieConsent, { Cookies } from "react-cookie-consent";
import { withTranslation, WithTranslation } from 'react-i18next';
import { init } from 'cookie-though';

import config from './config';

lockr.prefix = config.LOCKR_PREFIX as string;

import { Header, Layout, Spinner, Footer } from "./components";
import {
	Home,
	NewTeam,
	EditTeam,
	Stats,
	Rules,
	Join,
	Rankings,
	Forgot,
	PasswordReset,
	UserProfile,
	Terms,
	Register,
	Deadlines,
	Prizes,
	Points,
	Match,
	Team,
	Transfers,
	Leagues,
	Shop,
	Thanks,
	Privacy,
	Cookie,
	Club,
	LoginCallback,
	Eleven
} from "./pages";
import { GlobalStyle } from "./styles/global";

function loggedIn(): boolean {
	return !!lockr.get('token');
}

class App extends React.PureComponent<WithTranslation> {
	componentDidMount () {
		// @ts-ignore
		window.$crisp = [];
		// @ts-ignore
		window.CRISP_WEBSITE_ID = "516e73e5-c660-4651-bd08-ee72bae6a27d";

		(function() {
			var s = document.createElement("script");

			s.src = "https://client.crisp.chat/l.js";
			// @ts-ignore
			s.async = 1;
			document.getElementsByTagName("head")[0].appendChild(s);
		})();
	}

	render() {
		// if (window.location.pathname.includes('/nl')) {
		// 	this.props.i18n.changeLanguage('nl');

		// 	const newUrl = window.location.pathname.replace('/nl', '');
		// 	window.location.replace(newUrl === '' ? newUrl+ '/home' : newUrl)
		// }

		// if (window.location.pathname.includes('/fr')) {
		// 	this.props.i18n.changeLanguage('fr');

		// 	const newUrl = window.location.pathname.replace('/fr', '');
		// 	window.location.replace(newUrl === '' ? newUrl+ '/home' : newUrl)
		// }

		// init({
		// 	"policies": [
		// 		{
		// 		"id": "essential",
		// 		"label": this.props.t('cookies.label1'),
		// 		"description": this.props.t('cookies.description1'),
		// 		"category": "essential",
		// 		},
		// 		{
		// 		"id": "functional",
		// 		"label": this.props.t('cookies.label2'),
		// 		"category": "functional",
		// 		"description": this.props.t('cookies.description2'),
		// 		},
		// 		{
		// 		"id": "statistics",
		// 		"label": this.props.t('cookies.label3'),
		// 		"category": "statistics",
		// 		"description": this.props.t('cookies.description3'),
		// 		},
		// 		{
		// 		"id": "social",
		// 		"label": this.props.t('cookies.label4'),
		// 		"category": "social",
		// 		"description": this.props.t('cookies.description4'),
		// 		},
		// 	],
		// 	"essentialLabel": this.props.t('cookies.essentialLabel'),
		// 	"permissionLabels": {
		// 		"accept": this.props.t('cookies.permissionLabels.accept'),
		// 		"acceptAll": this.props.t('cookies.permissionLabels.acceptAll'),
		// 		"decline": this.props.t('cookies.permissionLabels.decline')
		// 	},
		// 	"cookiePreferenceKey": "cookie-preferences",
		// 	"header": {
		// 		"title": "Cookie Though",
		// 		"subTitle": "Fed up with cookies",
		// 		"description": this.props.t('cookies.header.description')
		// 	},
		// 	"cookiePolicy": {
		// 		"url": this.props.t('cookies.cookiePolicy.url'),
		// 		"label": this.props.t('cookies.cookiePolicy.label'),
		// 	},
		// 	"customizeLabel": this.props.t('cookies.customizeLabel')
		// })

		// @ts-ignore
		const PrivateRoute = ({ component: Component, ...rest }) => (
			<Route {...rest} render={props => (
				loggedIn() ? (<Component {...props} {...{ t: this.props.t }} />) : (<Redirect to={{ pathname: '/home', state: { from: props.location } }} />)
			)} />
		);

		// @ts-ignore
		const PublicOnlyRoute = ({ component: Component, ...rest }) => (
			<Route {...rest} render={props => (
				!loggedIn() ? (<Component {...props} {...{ t: this.props.t }} />) : (<Redirect to={{ pathname: '/home', state: { from: props.location } }} />)
			)} />
		);

		// @ts-ignore
		const UniversalRoute = ({ component: Component, ...rest }) => (
			<Route {...rest} render={props => ((<Component {...props} {...{ t: this.props.t, i18n: this.props.i18n }} />))} />
		);

		return (
			<ThemeProvider theme={theme}>
				<Router>
					<React.Fragment>
						<GlobalStyle />
						{/* <div style={{ minHeight: '100vh', margin: '0 auto -120px' }}> */}
							<Header {...{ t: this.props.t, i18n: this.props.i18n }} />
							<Spinner />
							<Layout>
								<PublicOnlyRoute exact path="/" component={Home} />
								<UniversalRoute path="/home" component={Home} />
								<PublicOnlyRoute path="/register" component={Register} />
								<PrivateRoute path="/new" component={NewTeam} />
								<PrivateRoute path="/leagues" component={Leagues} />
								<PrivateRoute path="/points/:id" component={Points} />
								<PrivateRoute path="/public/:id" component={Points} />
								<PrivateRoute path="/team/:id" component={Team} />
								<PrivateRoute path="/transfers/:id" component={Transfers} />
								<PrivateRoute path="/edit/:id" component={EditTeam} />
								<PrivateRoute path="/profile" component={UserProfile} />
								<PrivateRoute path="/join/:code" component={Join} />
								<UniversalRoute path="/rules" component={Rules} />
								<UniversalRoute path="/deadlines" component={Deadlines} />
								<UniversalRoute path="/terms" component={Terms} />
								<UniversalRoute path="/stats" component={Stats} />
								<UniversalRoute path="/match/:id" component={Match} />
								<UniversalRoute path="/prizes" component={Prizes} />
								<PublicOnlyRoute path="/forgot" component={Forgot} />
								<PublicOnlyRoute path="/reset-password/:resetToken" component={PasswordReset} />
								<UniversalRoute path="/rankings" component={Rankings} />
								<PrivateRoute path="/shop" component={Shop} />
								<PrivateRoute path="/thanks" component={Thanks} />
								<UniversalRoute path="/cookie" component={Cookie} />
								<UniversalRoute path="/privacy" component={Privacy} />
								<UniversalRoute path="/club/:id" component={Club} />
								<UniversalRoute path="/sso" component={LoginCallback}/>
								<UniversalRoute path="/eleven" component={Eleven}/>
							</Layout>
							<Footer {...{ t: this.props.t, i18n: this.props.i18n }} />
							{/* <div style={{ height: '120px' }}></div>
						</div> */}
					</React.Fragment>
				</Router>
			</ThemeProvider>
		);
	}
}

export default withTranslation('translation')(App);
